import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { Sorder } from '../entities/s-order';


export class SorderRequest extends BaseRequest {
    sorder : Sorder;
}
